// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"05ea321c","239":"103b88f5","667":"f8f5a774"}[chunkId] + ".chunk.js";
};